import { TimeoutError } from '@deephaven/utils';

/** Default timeout for fetching a variable definition */
export var FETCH_TIMEOUT = 10000;

/**
 * Fetch the definition for a variable given a connection. Waits for the next
 * field update event and resolves if the variable is found in the created
 * variables.
 * @param connection Connection to get the variable from
 * @param name Name of the definition to fetch
 * @param timeout Timeout for the fetch
 * @returns Promise that resolves to the variable definition if found in the next field update,
 *          or rejects if the variable is not found in that update or if the timeout is exceeded
 */
export function fetchVariableDefinition(connection, name) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : FETCH_TIMEOUT;
  return fetchVariableDefinitionByPredicate(connection, def => def.title === name, timeout, "Variable ".concat(name, " not found"));
}

/**
 * Fetch the definition for a variable given a connection. Waits for the next
 * field update event and resolves if a variable matching the predicate is found
 * in the created variables.
 * @param connection Connection to get the variable from
 * @param predicate Predicate function to test each variable definition
 * @param timeout Timeout for the fetch
 * @param errorMessage Optional error message for timeout and not found errors
 * @returns Promise that resolves to the variable definition if found in the next field update,
 *          or rejects if no matching variable is found in that update or if the timeout is exceeded
 */
export function fetchVariableDefinitionByPredicate(connection, predicate) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : FETCH_TIMEOUT;
  var errorMessage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Variable not found';
  return new Promise((resolve, reject) => {
    var removeListener;
    var timeoutId = setTimeout(() => {
      var _removeListener;
      (_removeListener = removeListener) === null || _removeListener === void 0 || _removeListener();
      reject(new TimeoutError("Timeout: ".concat(errorMessage)));
    }, timeout);

    /**
     * Checks if a variable matching the predicate is in the changes, and resolves the promise if it does
     * @param changes Variables changes that have occurred
     */
    function handleFieldUpdates(changes) {
      var _removeListener2;
      var definition = changes.created.find(predicate);
      clearTimeout(timeoutId);
      (_removeListener2 = removeListener) === null || _removeListener2 === void 0 || _removeListener2();
      if (definition != null) {
        resolve(definition);
      } else {
        reject(new Error(errorMessage));
      }
    }
    removeListener = connection.subscribeToFieldUpdates(handleFieldUpdates);
  });
}
//# sourceMappingURL=ConnectionUtils.js.map